import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SubscriptionTrialObject } from '../../types/Subscription';

interface State {
  trialData?: {
    type?: string;
    unit?: string;
    value?: number;
    fallback?: boolean;
  },
  candidateData?: {
    status?: string;
  },
  isMobile?: boolean;
  candidateHasFreeTrial?: boolean;
  hasTrialFallback?: boolean;
  subscription?: {
    id?: string;
    status?: string;
    trial?: any;
    createdAt?: string;
    candidateId?: number;
    planId?: number;
    history?: any;
    paymentMethod?: string;
  },
  trialHistory?: SubscriptionTrialObject[];
  profileId?: number;
  selectedProfileId?: number;
  trialEndDate?: string;
  isTestingCheckbox?: boolean;
  isLimitedApplyEnabled?: boolean;
  cpf?: string;
  email?: string;
  name?: string;
  sessionToken?: string;
  candidateId?: number;
  isLimitedApplyUser?: boolean;
  isBackendTermAccepted?: boolean;
  isFrontendTermAccepted?: boolean;
  isContractAccepted?: boolean;
  termHasError?: boolean;
  contractHasError?: boolean;
  transactionId?: string;
  isReturnUser?: boolean;
  planHasError?: boolean;
  paymentNotSelectedError?: boolean;
  typeInclusion?: any;
  emailInputValue?: string;
  cpfInputValue?: string;
  isContractAndTermsAcceptedPix?: boolean;
}


const initialState: State ={
 trialData: {
  type: 'DEFAULT',
  unit: 'DAY',
  value: 0,
  fallback: false,
},
candidateData: null,
isMobile: false,
candidateHasFreeTrial: false,
hasTrialFallback: false,
subscription: null,
profileId: null,
selectedProfileId: null,
trialEndDate: null,
isTestingCheckbox: false,
isLimitedApplyEnabled: false,
cpf: null,
email: null,
name: null,
sessionToken: null,
candidateId: null,
isLimitedApplyUser: null,
isBackendTermAccepted: false,
isFrontendTermAccepted: false,
isContractAccepted: false,
termHasError: false,
contractHasError: false,
transactionId: null,
isReturnUser: false,
planHasError: false,
paymentNotSelectedError: false,
typeInclusion: null,
emailInputValue: null,
cpfInputValue: null,
isContractAndTermsAcceptedPix: false,
trialHistory: [],
}

const candidate = createSlice({
  name: 'candidate',

  initialState,

  reducers: {
    isMobile(state, action: PayloadAction<boolean>) {
      state.isMobile = action.payload;
    },

    setSubscription(state, action: PayloadAction<any>) {
      let isReturnUser = false;
      let isLimitedApplyUser = false;

      if (action.payload.subscription) {
        isReturnUser = (
          action.payload.subscription.history && action.payload.subscription.history.length > 0
        ) || false;
      }

      if (action.payload.limitedApply) {
        isLimitedApplyUser = action.payload.limitedApply.isLimitedApplyUser;
      }

      state.subscription = action.payload.subscription;
      state.isLimitedApplyUser = isLimitedApplyUser;
      state.isReturnUser = isReturnUser;
    },

    setProfileId(state, action: PayloadAction<any>) {
      state.profileId = action.payload.profileId;
    },

    setSelectedProfileId(state, action: PayloadAction<any>) {
      state.selectedProfileId = action.payload.selectedProfileId;
    },

    setLimitedApply(state, action: PayloadAction<any>) {
      state.isLimitedApplyEnabled = action.payload.isLimitedApplyEnabled;
    },

    setCandidateInfos(state, action: PayloadAction<any>) {
      state.cpf = action.payload.cpf;
      state.email = action.payload.email;
      state.name = action.payload.name;
      state.sessionToken = action.payload.sessionToken;
      state.candidateId = action.payload.candidateId;
      state.candidateData = action.payload.candidateData;
    },

    setTermAcceptanceInBackend(state, action: PayloadAction<any>) {
      state.isBackendTermAccepted = action.payload.isBackendTermAccepted;
      state.termHasError = false;
    },

    setTermAcceptanceInFrontend(state, action: PayloadAction<any>) {
      state.isFrontendTermAccepted = action.payload.isFrontendTermAccepted;
      state.termHasError = false;
    },

    setContractAcceptance(state, action: PayloadAction<any>) {
      state.isContractAccepted = action.payload.isContractAccepted;
      state.contractHasError = false;
    },

    setTermHasError(state) {
      state.termHasError = true;
    },

    setContractHasError(state) {
      state.contractHasError = true;
    },

    setPlanHasError(state) {
      state.planHasError = true;
    },

    setTypeInclusion(state, action: PayloadAction<any>) {
      state.typeInclusion = action.payload.typeInclusion;
      state.transactionId = action.payload.transactionId;
    },

    setPaymentNotSelectedError(state, action: PayloadAction<any>) {
      state.paymentNotSelectedError = action.payload.paymentNotSelectedError;
    },

    setInputEmailValue(state, action: PayloadAction<any>) {
      state.emailInputValue = action.payload.emailInputValue;
    },

    setInputCpfValue(state, action: PayloadAction<any>) {
      state.cpfInputValue = action.payload.cpfInputValue;
    },

    setIsContractAndTermsAcceptedPix(state, action: PayloadAction<boolean>){
      state.isContractAndTermsAcceptedPix = action.payload;
    },

    setEmailValue(state, action: PayloadAction<string>) {
      state.email = action.payload;
    },

    setCPFValue(state, action: PayloadAction<string>) {
      state.cpf = action.payload;
    },

    setTrialHistory(state, action: PayloadAction<SubscriptionTrialObject[]>) {
      state.trialHistory = action.payload;
    }
  },
});

export const {
  isMobile,
  setSubscription,
  setProfileId,
  setSelectedProfileId,
  setLimitedApply,
  setCandidateInfos,
  setTermAcceptanceInBackend,
  setTermAcceptanceInFrontend,
  setContractAcceptance,
  setTermHasError,
  setContractHasError,
  setPlanHasError,
  setTypeInclusion,
  setPaymentNotSelectedError,
  setInputEmailValue,
  setInputCpfValue,
  setIsContractAndTermsAcceptedPix,
  setEmailValue,
  setCPFValue,
  setTrialHistory,
} = candidate.actions;

export default candidate.reducer;
